<template>

  <div class="contain">
    <header>麦斯特BOS系统拜访统计表</header>
    <div class="layout-login">
      <div class="tit-visit-sta"><span>{{this.dateStr}}拜访统计表</span><button class="time-visit-sta"
                @click="selectDate">时间筛选<img src="../../assets/images/icon-select-visit.png"></button></div>
      <div class="table-visit-content">
        <table cellpadding="0"
               cellspacing="0"
               border="1"
               bordercolor="#e4e4e4"
               class="table-visit-left">
          <tr>
            <th>客户类型</th>
          </tr>
          <tr v-for="(row,index) in this.static"
              :key="index">
            <td>{{row.custType}}</td>
          </tr>
        </table>
        <div class="table-visit-rcontent">
          <table cellpadding="0"
                 cellspacing="0"
                 border="1"
                 bordercolor="#e4e4e4"
                 class="table-visit-right">
            <tr>
              <th rowspan="2">系统客户总数<br>（单位：家）</th>
              <th rowspan="2">拜访客户总数<br>（单位：家）</th>
              <th rowspan="2">拜访占比<br>（拜访数/同类型总客户数）</th>
              <th colspan="4">拜访次数(1家客户存在多次拜访)</th>
            </tr>
            <tr>
              <th>面访打卡次数</th>
              <th>电话访问次数</th>
              <th>客户来访次数</th>
              <th>面访未打卡次数</th>
            </tr>
            <tr v-for="(row,index) in this.static"
                :key="index">
              <td v-if="row.custType!='总计'" class="color-blue">{{row.custAllNum}}</td>
              <td v-if="row.custType!='总计'" class="color-blue">{{row.visCustNum}}</td>
              <td v-if="row.custType!='总计'">{{row.visCustPer}}</td>
              <td v-if="row.custType!='总计'" class="color-green">{{row.faceNum}}</td>
              <td v-if="row.custType!='总计'" class="color-green">{{row.telNum}}</td>
              <td v-if="row.custType!='总计'" class="color-green">{{row.custVisNum}}</td>
              <td v-if="row.custType!='总计'" class="color-green">{{row.unCheckNum}}</td>

              <td v-if="row.custType=='总计'" class="colorred-tit-table">{{row.custAllNum}}</td>
              <td v-if="row.custType=='总计'" class="colorred-tit-table">{{row.visCustNum}}</td>
              <td v-if="row.custType=='总计'" calss="colorred-tit-table">--</td>
              <td v-if="row.custType=='总计'" class="colorred-tit-table">{{row.faceNum}}</td>
              <td v-if="row.custType=='总计'" class="colorred-tit-table">{{row.telNum}}</td>
              <td v-if="row.custType=='总计'" class="colorred-tit-table">{{row.custVisNum}}</td>
              <td v-if="row.custType=='总计'" class="colorred-tit-table">{{row.unCheckNum}}</td>
            </tr>
          </table>
        </div>
      </div>
      <div class="node-visit-note">
        <p class="tit-visit-note">客户类型说明</p>
        <div class="ele-visit-note">
          <p class="tit-ele-visit">已合作客户：</p>
          <p class="node-visit-note">A类：面访频率每1个月1次；大区年度毛利或营业额前10%的客户。</p>
          <p class="node-visit-note">B类：面访频率每2个月1次;A类除外，合作客户性质为:国有企业，政府机关，事业单位及上市公司的客户。</p>
          <p class="node-visit-note">C类:面访频率每3个月1次;A、B类除外，合作产品为:劳务派遣，人力外包，业务外包业务的客户。</p>
          <p class="node-visit-note">D类:面访频率每6个月1次;A、B、C类除外的客户。</p>
        </div>
        <div class="ele-visit-note">
          <p class="tit-ele-visit">未合作客户：</p>
          <p class="node-visit-note">移动体系:面访频率1个月1次;未合作的移动体系客户。</p>
          <p class="node-visit-note">KA:面访频率1个月1次;未合作的大客户。</p>
        </div>
      </div>
    </div>
    <!--密码弹窗-->
    <van-popup v-model="show"
               :close-on-click-overlay="tapclose">
      <input type="password"
             placeholder="请输入密码"
             class="text-login icon-password-login"
             v-model="password">
      <van-button type="info"
                  class="btn-login"
                  @click="checkPsw">确认</van-button>
    </van-popup>
    <!-- 日期弹窗 -->
    <van-popup v-model="dateShow"
               position="bottom">
      <div class="content-win-choice">
        <div class="content-btn-choice"><span class="color-gray"
                @click="cancel">取消</span><button class="sure-btn-choice"
                  @click="confirmDate">确认</button></div>
        <div class="content-time-select"><input type="text"
                 v-model="dateStart"
                 @click="setStartDate"
                 placeholder="开始时间"
                 :class="startActive"><span class="node-visit-time">至</span><input type="text"
                 v-model="dateEnd"
                 placeholder="结束时间"
                 :class="endActive"
                 @click="setEndDate"></div>
        <div>
          <van-datetime-picker v-model="timePicker.currentDate"
                               type="year-month"
                               :minDate="timePicker.minDate"
                               :maxDate="timePicker.maxDate"
                               :show-toolbar="timePicker.topShow"
                               :visible-item-count="timePicker.showNum"
                               @change="changeTime" />
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import staticModel from '../../api/model/static'

export default {
  name: 'Static',
  data() {
    return {
      static: [],
      dateStr: '',
      dateStart: null,
      dateEnd: null,
      password: '',
      show: false,
      tapclose: false,
      dateShow: false,
      timePicker: {
        minDate: new Date(1949, 9, 1),
        maxDate: new Date(),
        currentDate: new Date(),
        topShow: false,
        showNum: 4,
      },
      selStart: false,
      selEnd: false,
      selClass: ['text-time-select', 'act-text-time-sel'],
      unSelClass: ['text-time-select'],
      startActive: ['text-time-select', 'act-text-time-sel'],
      endActive: ['text-time-select'],
      nowDate:new Date()
    }
  },
  methods: {
    init() {
      this.dateStr =
      this.nowDate.getFullYear() +
        '-' +
        (this.nowDate.getMonth() + 1)
      this.getStatic()
    },

    async getStatic() {
      var res = await staticModel.getStatic({
        password: this.password,
        start: this.dateStart,
        end: this.dateEnd,
      })
      if (res.success) {
        var startTxt = this.nowDate.getFullYear() + '-' + (this.nowDate.getMonth() + 1)
        if (this.dateStart != null) {
          startTxt = this.dateStart
        }
        var endTxt = this.nowDate.getFullYear() + '-' + (this.nowDate.getMonth() + 1)
        if (this.dateEnd != null) {
          endTxt = this.dateEnd
        }
        if(startTxt!=endTxt){
          this.dateStr = startTxt + '至' + endTxt
        }else{
          this.dateStr = startTxt
        }
        this.static = res.data
      } else {
        this.$toast(res.msg)
      }
    },

    async checkPsw() {
      var res = await staticModel.CheckPsw({ password: this.password })
      if (res.success) {
        localStorage.setItem('StaicPsw', JSON.stringify({expire:res.data}))
        this.show = false
        this.init()
      } else {
        this.$toast(res.msg)
      }
    },

    selectDate() {
      this.setStartDate()
      if (this.dateEnd == null) {
        this.dateEnd = this.nowDate.getFullYear() + '-' + (this.nowDate.getMonth()+1)
        this.dateEndTime = this.timePicker.currentDate
      }
      this.dateShow = true
    },
    changeTime(picker) {
      let selTime = picker.getValues()
      this.timePicker.currentDate = new Date(selTime[0] + '-' + selTime[1])
      if (this.selStart) {
        this.dateStart = selTime[0] + '-' + selTime[1]
      } else if (this.selEnd) {
        this.dateEnd = selTime[0] + '-' + selTime[1]
      }
    },
    confirmDate() {
      this.dateShow = false
      this.getStatic()
    },
    cancel() {
      this.dateShow = false
    },
    setStartDate() {
      this.selStart = true
      this.selEnd = false
      this.startActive = this.selClass
      this.endActive = this.unSelClass
      if (this.dateStart == null) {
        this.dateStart = this.nowDate.getFullYear() + '-' + (this.nowDate.getMonth() + 1)
        this.timePicker.currentDate = new Date(
          this.nowDate.getFullYear() + '-' + (this.nowDate.getMonth() + 1)
        )
      } else {
        this.timePicker.currentDate = new Date(this.dateStart)
      }
    },
    setEndDate() {
      this.selStart = false
      this.selEnd = true
      this.startActive = this.unSelClass
      this.endActive = this.selClass
      if (this.dateEnd == null) {
        this.dateEnd = this.nowDate.getFullYear() + '-' + (this.nowDate.getMonth() + 1)
        this.timePicker.currentDate = new Date(
          this.nowDate.getFullYear()+'-'+(this.nowDate.getMonth() + 1)
        )
        this.dateEndTime = this.timePicker.currentDate
      } else {
        this.timePicker.currentDate = new Date(this.dateEnd)
        console.log(this.timePicker.currentDate)
      }
    },
  },
  mounted() {
    const psw = JSON.parse(localStorage.getItem('StaicPsw'))
    if(psw!=undefined){
      if(psw.expire<Date.now()){
        this.show=true
      }else{
        this.show=false
        this.init()
      }
    }else{
      this.show=true
    }
    var nowDate = new Date()
    if(nowDate.getDate()<=7){
      nowDate.setMonth(nowDate.getMonth()-1)
    }
    this.nowDate=nowDate
    // this.timePicker.maxDate = new Date()
  },
}
</script>

<style scoped>
.btn-login,
p.nac-nav-checklist,
.tit-ele-checklist,
.name-check-desc,
.chancel-desc-check,
.sure-desc-check,
.name-clock-atten,
.tit-clock,
.tit-visit-sta span,
.table-visit-left td,
.tit-visit-note,
.tit-ele-visit {
  font-weight: 600;
}
</style>